import baseFetch from './baseFetch';


export default async function(category='') {
    const request = await baseFetch("api/images/?category=" + category, {
        method: "GET",
    });
    return await request;
}
